import type { DateTime } from "luxon";

export interface TermDateNotices {
  /** Set when the term dates must be corrected before the change can be made at all. */
  blockingError?: string;
  /** Set when the term dates are allowed but have a consequence worth spelling out. */
  advisoryWarning?: string;
}

// Notices to show for the term of a subscription that is being activated immediately. `today` is a
// parameter rather than read from the clock so callers pin the boundary themselves: the term pickers work
// in UTC, so a UTC start-of-day belongs here.
export function getTermDateNotices(termStartDate: DateTime, termEndDate: DateTime, today: DateTime): TermDateNotices {
  return {
    // An inverted term is checked first — it is the thing to fix before the past-end rule means anything.
    // Activating a term that has already ended expires the subscription again on the spot, announcing an
    // expiry that never really happened, so that is refused rather than warned about.
    blockingError:
      termEndDate <= termStartDate
        ? "The term end date must be after the term start date."
        : termEndDate < today
        ? "The term end date cannot be in the past. Choose today or a later date."
        : undefined,
    // Back-dating or forward-dating the start to line up with an existing Zuora term is expected here, so a
    // future start is fine — it just does not delay activation.
    advisoryWarning:
      termStartDate > today
        ? "The term start date is in the future. The subscription will still be activated immediately, not on the start date."
        : undefined,
  };
}
